function updateTask(tasks, task) {
  const taskIndex = this.tasks.findIndex((v)=>v.id == task.id);
  const oldTask =
    tasks.splice(taskIndex, 1, task);
  return oldTask;
}

module.exports = {
  key: 'update',
  icon: 'md-create',
  name: '更新任务',
  do({tasks}, {task}) {
    return updateTask(tasks, task);
  },
  undo({tasks}, {task}) {
    return updateTask(tasks, task);
  },
};
